import { invokeApi } from "src/bl_libs/invokeApi";

export const getAllTemplatesList = async (page, rows, search) => {
  const requestObj = {
    path: `/api/form_template?search=${search}&page=${page}&limit=${rows}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const getAllTemplatesListByType = async (search) => {
  const requestObj = {
    path: `/api/form_template/all_form_template?search=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const getTemplateDetail = async (id) => {
  const requestObj = {
    path: `/api/form_template/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const addFormTemplate = async (data) => {
  const requestObj = {
    path: `/api/form_template`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const editFormTemplate = async (_id, data) => {
  const requestObj = {
    path: `/api/form_template/${_id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const deleteTemplate = async (_id) => {
  const requestObj = {
    path: `/api/form_template/${_id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const getTemplatesWithoutSearchAndInActive = async (data) => {
  const requestObj = {
    path: `api/feedback_template/get_feedback_template`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
